import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CommercialCompetenceService } from '../services/commercial-competence.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ConfirmComponent } from '../../shared/confirm/confirm.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { Router, ActivatedRoute } from '@angular/router';
import { CcSerasaModalComponent } from './cc-serasa-modal/cc-serasa-modal.component';
import * as moment from 'moment';

import { IMyDpOptions } from 'mydatepicker';

@Component({
	selector: 'app-commercial-competence',
	templateUrl: './commercial-competence.component.html',
	styleUrls: ['./commercial-competence.component.scss'],
	providers: [CommercialCompetenceService]
})
export class CommercialCompetenceComponent implements OnInit {

	@Input("propostaAlcadaID") proposalID;
	@Input("clientID") clientID;
	@Input("profileUser") profileUser;

	private blogTab = false;
	private logTab = false;

	private dataFundacao;

	//public cnpjMask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/\w/, /\w/, '.',/\w/, /\w/, /\w/, '.',/\w/, /\w/, /\w/, '/',/\w/, /\w/, /\w/, /\w/, '-',/\w/, /\w/];
	public cpfMask = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

	private userID; //Usuario logado
	private permissions; //Permissões do Usuario logado

	private proposalData;
	private proposalOriginalData; //Dados originais da proposta, nao alterados pela interface
	private clientTypes;
	private clientTypeDetails;
	private experienceTypes;
	private ctcList;

	private proposalDocuments = [];
	private tempDoc;

	private proposalPartners = [];
	private partnerIE;
	private partnerDocument;
	private partnerName;

	private cultureList;
	private selectedCultureIndex;
	private proposalMarkets;

	private productsList;
	private selectedProductIndex;
	private proposalProducts;

	public isLoaded: boolean = false;

	public maxProposalLc: number;

	private showLoader;

	private requiredMessages = []; //Mensagens de campos requeridos para determinadas ações;

	//Verificadores de exibição por Tipo de Proposta
	private showExperience;
	private showDocs;
	private showFoundation;
	private showConjuge;
	private showClientsizeAndAnual;
	private showCulture;
	private showPartners;
	private showMarketAndPartners;
	private showCommon;

	//Controladores de edição por Perfil
	private editCTCPosition;
	private editCreditPosition;
	private editAgentPosition;

	//Controladores de Botões
	private canSave;
	private canCancel;
	private canSendToCTC;
	private canRequestApproval;
	private canFixLimit;
	private canEditButton;
	private canDeny;

	//Controladores de edição de campos
	private canEdit;

	private today = new Date();

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() },
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};

	constructor(private commercialCompetenceService: CommercialCompetenceService, private flashMessagesService: FlashMessagesService, private dialogService: DialogService, private router: Router, private route: ActivatedRoute) {

	}

	ngOnInit() {
		this.userID = localStorage.getItem('yara.userID');
		this.permissions = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		let sub = this.route.params.subscribe(params => {
			if (params['action'] == "proposta-alcada") {
				this.openAccordion();
			}
		});
	}

	openAccordion() {
		setTimeout(() => {
			if ($(document).find("a[href='#collapseCommercialCompetence'").attr("aria-expanded") === "true") {
				$(document).find("a[href='#collapseCommercialCompetence'").trigger("click");
				this.loadProposal();
			}
		}, 1000);
	}

	loadProposal() {
		if (!this.isLoaded) {
			this.showLoader = true;
			this.commercialCompetenceService.proposalID = this.proposalID;
			this.getProposalData();
			this.getClientTypes();
			this.getExperienceTypes();
			this.getCultureList();
			this.getProductsList();
			this.getAlcadaMaxProposalValue();
			this.getCTCByAccountClient();
			this.fixedButtons();
			this.isLoaded = true;
			this.showLoader = false;
		}
	}

	getAlcadaMaxProposalValue() {
		this.commercialCompetenceService.getAlcadaMaxProposalValue().subscribe(result => {
			if (result.Success) {
				for (var key in result.Result) {
					var obj = result.Result[key];
					if (obj.Chave === 'vlmaxalcada') {
						this.maxProposalLc = Number(obj.Valor);
					}
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	fixedButtons() {
		$(window).bind('scroll', function () {
			if ($('.proposal-breadcrumb').offset()) {
				if ($(window).scrollTop() > $('.proposal-breadcrumb').offset().top) {
					$('.proposal-buttons').addClass('fixed');
				} else {
					$('.proposal-buttons').removeClass('fixed');
				}
			}
		});
	}

	percentualCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength);
		} else {
			if (e.target.value > 100) {
				e.target.value = 100;
			} else if (e.target.value < 0) {
				e.target.value = 0;
			}
		}
	}

	clientTypeChanged() {
		this.getClientTypeDetails();
	}

	proposalRules() {
		return (this.proposalData.LCProposto > this.maxProposalLc);
	}

	checkRequiredFields() {
		// RESET
		this.requiredMessages = [];

		if (!this.proposalData.TipoClienteID) {
			this.requiredMessages.push("É necessário informar um Tipo de Cliente.");
		}
		if (!this.proposalData.CodigoSap) {
			this.requiredMessages.push("O campo CTC é obrigatório.");
		}
		if (!this.proposalData.TermoAceite) {
			this.requiredMessages.push("É necessário aceitar o termo de responsabilidade.");
		}
		if (this.commercialCompetenceService.proposalCultures.length === 0) {
			this.requiredMessages.push('Preencha pelo menos uma Cultura.');
		}
		if (this.showMarketAndPartners && this.proposalProducts.length === 0) {
			this.requiredMessages.push('Preencha pelo menos um Produto.');
		}
		if (!this.proposalData.LCProposto || this.proposalData.LCProposto < 0) {
			this.requiredMessages.push("É necessário informar o LC Proposto.");
		}
		if (!this.proposalData.SharePretendido || this.proposalData.SharePretendido < 0 || this.proposalData.SharePretendido > 100) {
			this.requiredMessages.push("É necessário informar o Share Pretendido.");
		}
		if (!this.proposalData.PrazoDias || this.proposalData.PrazoDias < 0) {
			this.requiredMessages.push("É necessário informar o Prazo em Dias.");
		}
		if (!this.proposalData.FontePagamento || this.proposalData.FontePagamento == "" || this.proposalData.FontePagamento.length > 120) {
			this.requiredMessages.push("É necessário informar a Fonte de Recursos para pagamento. (max. 120 caracteres)");
		}
		if (this.profileUser == "Representante") {
			if (!this.proposalData.ParecerRepresentante || this.proposalData.ParecerRepresentante.length < 100) {
				this.requiredMessages.push("É necessário informar o Parecer do Representante. (min. 100 caracteres)");
			}
		}
		if (this.profileUser == "Consultor Técnico Comercial") {
			if (!this.proposalData.ParecerCTC || this.proposalData.ParecerCTC.length < 100) {
				this.requiredMessages.push("É necessário informar o Parecer do CTC. (min. 100 caracteres)");
			}
		}
		if (this.profileUser == "Gerente Comercial") {
			if (!this.proposalData.ParecerCTC || this.proposalData.ParecerCTC.length < 100) {
				this.requiredMessages.push("É necessário informar o Parecer (min. 100 caracteres)");
			}
		}
		if (this.profileUser.indexOf("Crédito") != -1) {
			if (!this.proposalData.ParecerCredito || this.proposalData.ParecerCredito.length < 100) {
				this.requiredMessages.push("É necessário informar o Parecer do Crédito. (min. 100 caracteres)");
			}
		}

		return !(this.requiredMessages.length > 0);
	}

	checkProposalPermissions() {
		// RESET
		this.canSave = false;
		this.canCancel = false;
		this.canSendToCTC = false;
		this.canRequestApproval = false;
		this.canFixLimit = false;
		this.canEditButton = false;
		this.canEdit = false;
		this.canDeny = false;
		this.editCTCPosition = false;
		this.editCreditPosition = false;
		this.editAgentPosition = false;

		// ============== PROPOSTA EM CRIAÇÃO ===================
		if (this.proposalData.PropostaCobrancaStatusID == "EC") {

			// PERMISSIONS

			if (this.profileUser == "Representante") {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canSendToCTC = this.permissions.AlcadaComl_EnviaCTC ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editAgentPosition = true;
				}
			}

			if (this.profileUser == "Consultor Técnico Comercial") {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canRequestApproval = this.permissions.AlcadaComl_SolicitarAprovacao ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editCTCPosition = true;
				} else {
					this.canEditButton = this.permissions.AlcadaComl_Editar ? true : false;
				}
			}

			if (this.profileUser.indexOf("Crédito") != -1) {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canRequestApproval = this.permissions.AlcadaComl_SolicitarAprovacao ? true : false;
					this.canSendToCTC = this.permissions.AlcadaComl_EnviaCTC ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editCreditPosition = true;
				} else {
					this.canEditButton = this.permissions.AlcadaComl_Editar ? true : false;
				}
			}

			if (this.profileUser == "Gerente Comercial") {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canRequestApproval = this.permissions.AlcadaComl_SolicitarAprovacao ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editCTCPosition = true;
				} else {
					this.canEditButton = this.permissions.AlcadaComl_Editar ? true : false;
				}
			}
		}

		// ============== PROPOSTA AGUARDANDO CTC ===================
		if (this.proposalData.PropostaCobrancaStatusID == "ET") {

			if (this.profileUser == "Representante") {
				
			}

			if (this.profileUser == "Consultor Técnico Comercial") {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canRequestApproval = this.permissions.AlcadaComl_SolicitarAprovacao ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editCTCPosition = true;
				} else {
					
				}
			}

			if (this.profileUser.indexOf("Crédito") != -1) {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canRequestApproval = this.permissions.AlcadaComl_SolicitarAprovacao ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editCreditPosition = true;
				} else {
					this.canEditButton = this.permissions.AlcadaComl_Editar ? true : false;
				}
			}

			if (this.profileUser == "Gerente Comercial") {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canSave = this.permissions.AlcadaComl_Editar ? true : false;
					this.canCancel = this.permissions.AlcadaComl_Encerrar ? true : false;
					this.canRequestApproval = this.permissions.AlcadaComl_SolicitarAprovacao ? true : false;
					this.canEdit = this.permissions.AlcadaComl_Editar ? true : false;
					this.editCTCPosition = true;
				} else {
					
				}
			}
		}

		// ============== PROPOSTA EM APROVAÇÃO ===================
		if (this.proposalData.PropostaCobrancaStatusID == "EA") {

			if (this.profileUser == "Representante") {
				
			}

			if (this.profileUser == "Consultor Técnico Comercial") {
				
			}

			if (this.profileUser.indexOf("Crédito") != -1) {
				if (this.proposalData.ResponsavelID == this.userID) {
					this.canFixLimit = this.permissions.AlcadaComl_Fixar ? true : false;
					this.canDeny = this.permissions.AlcadaComl_Rejeitar ? true : false;
					this.editCreditPosition = true;
				} else {
					this.canEditButton = this.permissions.AlcadaComl_Editar ? true : false;
				}
			}
		}
	}

	onDeny() {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmar Rejeição',
			message: 'Confirma a rejeição da Proposta de Alçada Comercial?'
		},
		{
			backdropColor: 'rgba(0, 0, 0, 0.5)'
		}).subscribe((isConfirmed) => {
			if (isConfirmed) {
				this.deny();
			}
			else {

			}
		});

		setTimeout(() => {
			disposable.unsubscribe();
		}, 15000);
	}

	deny() {
		this.commercialCompetenceService.denyProposal(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta Rejeitada!", { cssClass: 'alert-success', timeout: 6000 });
				this.reloadClient();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	checkProposalType() {
		// RESET
		this.showExperience = false;
		this.showDocs = false;
		this.showFoundation = false;
		this.showConjuge = false;
		this.showClientsizeAndAnual = false;
		this.showCulture = false;
		this.showPartners = false;
		this.showMarketAndPartners = false;
		this.showCommon = false;

		if (this.clientTypeDetails.LayoutProposta == 0) {
			// Não definido
		}
		else if (this.clientTypeDetails.LayoutProposta == 1) {
			// Pessoa Fisica
			this.showExperience = true;
			this.showConjuge = true;
			this.showCulture = true;
			this.showCommon = true;
		}
		else if (this.clientTypeDetails.LayoutProposta == 2) {
			// Agropecuária
			this.showFoundation = true;
			this.showClientsizeAndAnual = true;
			this.showMarketAndPartners = true;
			this.showCommon = true;
		}
		else if (this.clientTypeDetails.LayoutProposta == 3) {
			// Revenda
			this.showFoundation = true;
			this.showClientsizeAndAnual = true;
			this.showMarketAndPartners = true;
			this.showCommon = true;
		}
		else if (this.clientTypeDetails.LayoutProposta == 4) {
			// Usina
			this.showFoundation = true;
			this.showClientsizeAndAnual = true;
			this.showMarketAndPartners = true;
			this.showCommon = true;
		}
		else if (this.clientTypeDetails.LayoutProposta == 5) {
			// Quimicos
			this.showFoundation = true;
			this.showClientsizeAndAnual = true;
			this.showMarketAndPartners = true;
			this.showCommon = true;
		}
		else if (this.clientTypeDetails.LayoutProposta == 6) {
			// PF com PJ
			this.showExperience = true;
			this.showConjuge = true;
			this.showCulture = true;
			this.showDocs = true;
			this.showCommon = true;
		}
		else if (this.clientTypeDetails.LayoutProposta == 7) {
			// PF com Parceria
			this.showExperience = true;
			this.showConjuge = true;
			this.showCulture = true;
			this.showPartners = true;
			this.showCommon = true;
		}
	}

	onEditProposal() {
		this.commercialCompetenceService.editProposal(this.proposalData.ID).subscribe(result => {
			if (result.Success) {
				this.getProposalData();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getClientTypeDetails() {
		this.commercialCompetenceService.getClientTypeByID(this.proposalData.TipoClienteID).subscribe(result => {
			if (result.Success) {
				this.clientTypeDetails = result.Result;
				this.checkProposalType();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getProductsList() {
		this.commercialCompetenceService.getProductsList().subscribe(result => {
			if (result.Success) {
				this.productsList = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getCultureList() {
		this.commercialCompetenceService.getCultureList().subscribe(result => {
			if (result.Success) {
				this.cultureList = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getProposalData() {
		this.commercialCompetenceService.getProposalData(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.proposalData = result.Result;
				this.checkProposalPermissions();

				this.proposalOriginalData = result.Result;
				this.proposalDocuments = result.Result.Documentos;
				this.commercialCompetenceService.proposalCultures = result.Result.Culturas;
				this.proposalPartners = result.Result.ParceriasAgricolas;
				this.proposalProducts = result.Result.Produtos;

				if (result.Result.DataFundacao) {
					const tempDate = moment(result.Result.DataFundacao).toDate();
					this.dataFundacao = { date: { year: tempDate.getFullYear(), month: tempDate.getMonth() + 1, day: tempDate.getDate() } }
				}

				this.flashMessagesService.show("Proposta de Alçada Comercial carregada!", { cssClass: 'alert-success', timeout: 6000 });
				if (this.proposalData.TipoClienteID) {
					this.getClientTypeDetails();
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	// CNPJ
	insertCnpj() {
		this.proposalDocuments.push({
			Documento: this.tempDoc.replace(/[^a-zA-Z0-9]+/g, '')
		});

		this.tempDoc = null;
	}

	// Confere se o CNPJ tem 14 caracteres. 
	checkCNPJLength() {
		return !(!this.tempDoc || this.tempDoc.replace(/[^a-zA-Z0-9]+/g, '').length < 14);
	}

	// Confere se o CPF tem 14 caracteres. 
	checkCPFLength() {
		return !(!this.tempDoc || this.tempDoc.replace(/[^a-zA-Z0-9]+/g, '').length < 11)
	}

	onConjugeDocChange() {
		const cleanDoc = this.proposalData.CPFConjugue.replace(/[^a-zA-Z0-9]+/g, '');
		if (cleanDoc.length == 11) {
			this.commercialCompetenceService.searchNameByDoc(cleanDoc).subscribe(result => {
				if (result.Success) {
					if (result.Result.length > 0) {
						this.proposalData.NomeConjugue = result.Result[0].Nome;
					}
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	onPartnerDocChange() {
		const cleanDoc = this.partnerDocument.replace(/[^a-zA-Z0-9]+/g, '');
		if (cleanDoc.length == 11) {
			this.commercialCompetenceService.searchNameByDoc(cleanDoc).subscribe(result => {
				if (result.Success) {
					if (result.Result.length > 0) {
						this.partnerName = result.Result[0].Nome;
					}
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		}
	}

	removeCnpj(index) {
		this.proposalDocuments.splice(index, 1);
	}

	// PARTNERS
	addPartner() {
		this.proposalPartners.push({
			Documento: this.partnerDocument.replace(/[^a-zA-Z0-9]+/g, ''),
			InscricaoEstadual: this.partnerIE,
			Nome: this.partnerName
		});

		this.partnerDocument = null;
		this.partnerIE = null;
		this.partnerName = null;
	}

	removePartner(index) {
		this.proposalPartners.splice(index, 1);
	}

	// MARKETS
	addMarket() {
		this.commercialCompetenceService.proposalCultures.push({
			CulturaID: this.cultureList[this.selectedCultureIndex].ID,
			CulturaNome: this.cultureList[this.selectedCultureIndex].Descricao
		});

		this.selectedCultureIndex = null;
	}

	removeMarket(index) {
		this.commercialCompetenceService.proposalCultures.splice(index, 1);
	}

	// PRODUCTS
	addProduct() {
		this.proposalProducts.push({
			ProdutoServicoID: this.productsList[this.selectedProductIndex].ID,
			ProdutoServicoNome: this.productsList[this.selectedProductIndex].Nome
		});

		this.selectedProductIndex = null;
	}

	removeProduct(index) {
		this.proposalProducts.splice(index, 1);
	}

	// COMMON
	onCancel() {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmar Encerramento',
			message: 'Confirma o encerramento da Proposta de Alçada Comercial?'
		},
		{
			backdropColor: 'rgba(0, 0, 0, 0.5)'
		}).subscribe((isConfirmed) => {
			if (isConfirmed) {
				this.cancelProposal();
			}
			else {
				
			}
		});

		setTimeout(() => {
			disposable.unsubscribe();
		}, 15000);
	}

	onfixLimit() {
		if (this.checkRequiredFields()) {
			this.saveProposalData();
			let disposable = this.dialogService.addDialog(ConfirmComponent, {
				title: 'Confirmar Fixação',
				message: 'Deseja realmente Fixar o Limite para o cliente?'
			},
			{
				backdropColor: 'rgba(0, 0, 0, 0.5)'
			}).subscribe((isConfirmed) => {
				if (isConfirmed) {
					this.approve();
				}
				else {

				}
			});

			setTimeout(() => {
				disposable.unsubscribe();
			}, 15000);
		}
	}

	onSendToCTC() {
		const objToSend =
		{
			TipoClienteID: this.proposalData.TipoClienteID,
			CodigoSap: this.proposalData.CodigoSap,
			ContaClienteID: this.proposalData.ContaClienteID,
			ExperienciaID: this.proposalData.ExperienciaID,
			TipoGarantiaaID: "",
			ParceriasAgricolas: this.proposalPartners,
			Culturas: this.commercialCompetenceService.proposalCultures,
			Produtos: this.proposalProducts,
			Documentos: this.proposalDocuments,
			PorteCliente: this.proposalData.PorteCliente,
			FaturamentoAnual: this.proposalData.FaturamentoAnual,
			TermoAceite: this.proposalData.TermoAceite,
			EstadoCivil: this.proposalData.EstadoCivil,
			CPFConjugue: this.proposalData.CPFConjugue ? this.proposalData.CPFConjugue.replace(/[^a-zA-Z0-9]+/g, '') : '',
			NomeConjugue: this.proposalData.NomeConjugue,
			RegimeCasamento: this.proposalData.RegimeCasamento,
			LCProposto: this.proposalData.LCProposto,
			SharePretendido: this.proposalData.SharePretendido,
			PrazoDias: this.proposalData.PrazoDias,
			FontePagamento: this.proposalData.FontePagamento,
			ParecerRepresentante: this.proposalData.ParecerRepresentante,
			ParecerCTC: this.proposalData.ParecerCTC,
			ParecerCredito: this.proposalData.ParecerCredito,
			DataFundacao: this.dataFundacao ? this.dataFundacao.date.year + "-" + this.dataFundacao.date.month + "-" + this.dataFundacao.date.day : null,
			ID: this.proposalData.ID
		}

		this.commercialCompetenceService.saveProposalData(objToSend).subscribe(result => {
			if (result.Success) {
				if (this.checkRequiredFields()) {
					this.sendToCTC();
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	sendToCTC() {
		var obj = {
			ID: this.proposalID,
			CodigoSap: this.proposalData.CodigoSap
		}

		this.showLoader = true;
		this.commercialCompetenceService.sendProposalToCtc(obj).subscribe(result => {
			if (result.Success) {
				this.showLoader = false;
				this.flashMessagesService.show("Proposta enviada ao CTC.", { cssClass: 'alert-success', timeout: 6000 });

				this.isLoaded = false;
				this.loadProposal();
			} else {
				this.showLoader = false;
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	cancelProposal() {
		this.commercialCompetenceService.cancelProposal(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta Cancelada!", { cssClass: 'alert-success', timeout: 6000 });
				this.reloadClient();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	saveProposalData() {
		if (this.checkRequiredFields())
		{
			const objToSend =
			{
				TipoClienteID: this.proposalData.TipoClienteID,
				CodigoSap: this.proposalData.CodigoSap,
				ContaClienteID: this.proposalData.ContaClienteID,
				ExperienciaID: this.proposalData.ExperienciaID,
				TipoGarantiaaID: "",
				ParceriasAgricolas: this.proposalPartners,
				Culturas: this.commercialCompetenceService.proposalCultures,
				Produtos: this.proposalProducts,
				Documentos: this.proposalDocuments,
				PorteCliente: this.proposalData.PorteCliente,
				FaturamentoAnual: this.proposalData.FaturamentoAnual,
				TermoAceite: this.proposalData.TermoAceite,
				EstadoCivil: this.proposalData.EstadoCivil,
				CPFConjugue: this.proposalData.CPFConjugue ? this.proposalData.CPFConjugue.replace(/[^a-zA-Z0-9]+/g, '') : '',
				NomeConjugue: this.proposalData.NomeConjugue,
				RegimeCasamento: this.proposalData.RegimeCasamento,
				LCProposto: this.proposalData.LCProposto,
				SharePretendido: this.proposalData.SharePretendido,
				PrazoDias: this.proposalData.PrazoDias,
				FontePagamento: this.proposalData.FontePagamento,
				ParecerRepresentante: this.proposalData.ParecerRepresentante,
				ParecerCTC: this.proposalData.ParecerCTC,
				ParecerCredito: this.proposalData.ParecerCredito,
				Acompanhar: this.proposalData.Acompanhar,
				DataFundacao: this.dataFundacao ? this.dataFundacao.date.year + "-" + this.dataFundacao.date.month + "-" + this.dataFundacao.date.day : null,
				ID: this.proposalData.ID
			}
	
			this.commercialCompetenceService.saveProposalData(objToSend).subscribe(result => {
				if (result.Success) {
					console.log("proposta Salva", result);
					this.flashMessagesService.show("Proposta de Alçada Comercial salva!", { cssClass: 'alert-success', timeout: 6000 });
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});	
		}
	}

	onRequestApproval() {
		const objToSend =
		{
			TipoClienteID: this.proposalData.TipoClienteID,
			CodigoSap: this.proposalData.CodigoSap,
			ContaClienteID: this.proposalData.ContaClienteID,
			ExperienciaID: this.proposalData.ExperienciaID,
			TipoGarantiaaID: "",
			ParceriasAgricolas: this.proposalPartners,
			Culturas: this.commercialCompetenceService.proposalCultures,
			Produtos: this.proposalProducts,
			Documentos: this.proposalDocuments,
			PorteCliente: this.proposalData.PorteCliente,
			FaturamentoAnual: this.proposalData.FaturamentoAnual,
			TermoAceite: this.proposalData.TermoAceite,
			EstadoCivil: this.proposalData.EstadoCivil,
			CPFConjugue: this.proposalData.CPFConjugue ? this.proposalData.CPFConjugue.replace(/[^a-zA-Z0-9]+/g, '') : '',
			NomeConjugue: this.proposalData.NomeConjugue,
			RegimeCasamento: this.proposalData.RegimeCasamento,
			LCProposto: this.proposalData.LCProposto,
			SharePretendido: this.proposalData.SharePretendido,
			PrazoDias: this.proposalData.PrazoDias,
			FontePagamento: this.proposalData.FontePagamento,
			ParecerRepresentante: this.proposalData.ParecerRepresentante,
			ParecerCTC: this.proposalData.ParecerCTC,
			ParecerCredito: this.proposalData.ParecerCredito,
			DataFundacao: this.dataFundacao ? this.dataFundacao.date.year + "-" + this.dataFundacao.date.month + "-" + this.dataFundacao.date.day : null,
			ID: this.proposalData.ID
		}

		this.commercialCompetenceService.saveProposalData(objToSend).subscribe(result => {
			if (result.Success) {
				if (this.checkRequiredFields()) {
					this.requestApproval();
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	requestApproval() {
		this.showLoader = true;
		this.commercialCompetenceService.checkSerasa(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.showLoader = false;
				if (result.Result) {
					this.showSerasaModal("Restrição no Serasa detectada.");
				} else {
					this.approveByCTC();
				}
			} else {
				this.showLoader = false;
				this.showSerasaModal(result.Errors);
			}
		}, error => {
			console.log(error);
		});
	}

	showSerasaModal(pendencia) {
		var obj = {
			ID: this.proposalID,
			CodigoSap: this.proposalData.CodigoSap
		}

		this.dialogService.addDialog(CcSerasaModalComponent, {
			pendencia: pendencia,
			objSerasa: obj,
			proposalID: this.proposalID,
			clientID: this.clientID
		},
		{
			backdropColor: 'rgba(0, 0, 0, 0.5)'
		})
	}

	approve() {
		this.commercialCompetenceService.approveProposal(this.proposalID, this.proposalData.ContaClienteID).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Alçada Comercial Aprovada!", { cssClass: 'alert-success', timeout: 6000 });
				this.flashMessagesService.show("Limite de crédito fixado!", { cssClass: 'alert-success', timeout: 6000 });
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 12000 });
			}
			this.reloadClient();
		}, error => {
			console.log(error);
		});
	}

	approveByCTC() {
		this.commercialCompetenceService.aproveByCTC(this.proposalID, this.proposalData.ContaClienteID).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Alçada Comercial Aprovada!", { cssClass: 'alert-success', timeout: 6000 });
				this.flashMessagesService.show("Limite de crédito fixado!", { cssClass: 'alert-success', timeout: 6000 });
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 12000 });
			}
			this.reloadClient();
		}, error => {
			console.log(error);
		});
	}

	reloadClient() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.clientID);
			});
	}

	getClientTypes() {
		this.commercialCompetenceService.getClientTypes().subscribe(result => {
			if (result.Success) {
				this.clientTypes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getExperienceTypes() {
		this.commercialCompetenceService.getExperienceTypes().subscribe(result => {
			if (result.Success) {
				this.experienceTypes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getCTCByAccountClient() {
		this.commercialCompetenceService.getCtcByAccountClient(this.clientID).subscribe(result => {
			if (result.Success) {
				this.ctcList = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/commercial-competence/commercial-competence/commercial-competence.component.ts